import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import fileDownload from 'js-file-download';
import { toast } from 'react-toastify';
import { getScriptPaymentsRequest } from '../../../../../store/actions/script';
import classes from './tabs.module.scss';
import Loader from '../../../../_common/Loader/Loader';
import accountHelpers from '../../../../../utils/accountHelpers';
import { setLoadingProgress } from '../../../../../store/actions/loadingProgess';
import LoadingProgress from '../../../../_common/LoadingProgress/LoadingProgress';
import Button from '../../../../_common/Form/Buttons/Button';
import Api from '../../../../../api/api';
import Modal from '../../../../_common/Modal/Modal';
import InputField from '../../../../_common/Form/TextFields/InputField';
import utils from '../../../../../utils/utils';

const header = ['Patient name', 'Medication', 'Amount', 'Payment Processed On', 'Refund'];

const Payments = () => {
  const { scriptId } = useParams();

  const dispatch = useDispatch();
  const { scriptPayments, requestStatus, patientScriptData } = useSelector((store) => store.script);
  const { loadProgress } = useSelector((store) => store.loadingProgress);

  const [refundData, setRefundData] = useState({});
  const [amount, setAmount] = useState('');
  const [refundLoading, refundLoadingToggle] = useState(false);

  const { totalAmount, transactionId } = refundData;

  useEffect(() => {
    dispatch(getScriptPaymentsRequest({ scriptId }));
  }, []);

  const balanceRemaining = () => {
    let balance = 0;

    scriptPayments.forEach((s) => { balance += +s.amount; });

    return balance;
  };

  const getScriptPaymentPdfRequest = async (receiptId) => {
    const fileName = `receipt-${receiptId}.pdf`;
    if (loadProgress.status) {
      toast.error('please with finished download file');
      return;
    }

    try {
      dispatch(setLoadingProgress({
        status: 'Download start',
        percent: 0,
      }));

      const { data } = await Api.getScriptPaymentsPdf({
        fileName,
        receiptId,
        userId: accountHelpers.getUser().id,
      }, ({ total, loaded }) => {
        const percent = Math.round((loaded * 100) / total);

        dispatch(setLoadingProgress({
          status: 'Loading',
          percent,
        }));
      });

      if (data === 'Signing unsuccessful.') {
        toast.error(data);

        dispatch(setLoadingProgress({
          status: '',
          percent: 0,
        }));
      } else {
        await fileDownload(new Uint8Array(data.Body.data), fileName);

        toast.success('Download completed');
        dispatch(setLoadingProgress({
          status: 'Download completed',
          percent: 0,
        }));

        const timeout = setTimeout(() => {
          dispatch(setLoadingProgress({
            status: '',
            percent: 0,
          }));

          clearTimeout(timeout);
        }, 1000);
      }
    } catch (e) {
      console.warn(e);

      dispatch(setLoadingProgress({
        status: '',
        percent: 0,
      }));

      toast.error(`Unable to retrieving ${fileName}`);
    }
  };

  const openRefundModal = (receipt) => {
    setRefundData(receipt);
    setAmount(receipt.totalAmount);
  };

  const changeAmount = (value) => {
    if (+value <= +totalAmount) {
      setAmount(value);
    }
  };

  const sendRefundRequest = async () => {
    refundLoadingToggle(true);

    try {
      await Api.sendRefund({ transactionId, amount });
      toast.success('Credit card successfully refunded.');
      setRefundData({});
    } catch (err) {
      toast.error(err.response.data?.message || 'Something wrong please try agan!');
    }

    refundLoadingToggle(false);
  };

  return (
    requestStatus === 'request'
      ? (
        <div className={classes.status_loader}>
          <Loader />
        </div>
      )

      : (
        <div className={classes.script_payment_wrapper}>

          {requestStatus === 'success' && (
          <>
            {!scriptPayments.length
              ? <div className={classes.notResult}>No Data Found</div>

              : (
                <div className={classes.table_wrapper}>
                  <div>
                    <table>
                      <thead>
                        <tr>
                          {header.map((h) => (
                            <th key={h}>{h}</th>
                          ))}
                        </tr>
                      </thead>

                      <tbody id="tbody">
                        {scriptPayments.map((s) => (
                          <tr key={`${s.id}`} onClick={() => getScriptPaymentPdfRequest(s.receiptId)}>
                            <td>
                              {`${patientScriptData[0].Patient.firstName} ${patientScriptData[0].Patient.lastName}`}
                            </td>

                            <td>
                              {patientScriptData[0].Product.name}
                            </td>

                            <td>{`$ ${s.amount}`}</td>

                            <td>{moment(s.createdAt).format('MM/DD/YYYY')}</td>

                            <td onClick={(e) => e.stopPropagation()}>
                              <Button
                                onClick={() => openRefundModal(s.receipt)}
                                loading={false}
                                title="Refund"
                                className={classes.refund_button}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className={classes.balance}>
                    <p>Balance Remaining</p>

                    <span>{`$ ${balanceRemaining()}`}</span>
                  </div>
                </div>
              )}
          </>
          )}

          <Modal
            className={classes.payment_modal_wrapper}
            open={!!transactionId}
            onClose={() => setRefundData({})}
          >
            <h2>Refund amount</h2>

            <InputField
              onChange={changeAmount}
              value={amount}
              label={`Max amount ${totalAmount}$`}
              onKeyPress={(e) => utils.keyPressCurrency(e, false, +totalAmount, 2)}
              onPaste={(e) => utils.keyPressCurrency(e, true, +totalAmount, 2)}
            />

            <div className={classes.btns_wrapper}>
              <Button
                title="Cancel"
                type="button"
                onClick={() => setRefundData({})}
                clearButton
              />

              <Button
                title="Apply"
                type="button"
                loading={refundLoading}
                onClick={sendRefundRequest}
              />
            </div>
          </Modal>
        </div>
      )
  );
};

export default Payments;
